export const environment = {
    defaultLang: 'en',
    adultAge: 18,
    production: false,
    host: 'https://cube.ayntap.com/api',
    gtnHost: 'https://api-mena-uat.globaltradingnetwork.com',
    throttleKey: '#X7i}zKRJ=54)LkMSt+Gl@HFAd~)',
    uploadHostUrl: 'https://cube.ayntap.com/api',
    uploaderFilesBaseUrl: 'https://cube.ayntap.com/images',
    extensionHost: 'https://cube.ayntap.com/api',
    storageServerUrl: 'https://cube.ayntap.com',
    socketUrl: 'wss://cube.ayntap.com/ws',
    appTitle: 'Cube',
    portalUrl: 'https://tradingapi.cubeinvest.am/trading',
    priceMultiplicator: 10000000000,
    quantityMultiplicator: 1000000,
    reCaptchaSiteKey: '6Ld7glUtAAAAANJMRxBYhzyaRc5wfpsqpHCni4Ig',
    version: '1.0.0',
    beErrorLangKey: 'BACKEND_ERRORS',
    maxUploadSizeInMB: 3,
    unavailableCountries: ['US'],
    cookie: {
        secure: true,
        domain: 'tradingapi.cubeinvest.am'
    },
    firebase: {
        apiKey: 'AIzaSyA38WyespLkjduPzE733fT0ekFM6HNkLjE',
        authDomain: 'testexchangepush.firebaseapp.com',
        databaseURL: 'https://testexchangepush.firebaseio.com',
        projectId: 'testexchangepush',
        storageBucket: 'testexchangepush.appspot.com',
        messagingSenderId: '472555660346',
        appId: '1:472555660346:web:eb8783c9e59c8e67720103',
        measurementId: 'G-EXG88WK1N1'
    },
    firebaseAuth: {
        apiKey: 'AIzaSyCtdPDJ9Zxc2AeKJi5OV2pjDf-nU2U8jHI',
        authDomain: 'cube-broker.firebaseapp.com',
        projectId: 'cube-broker',
        storageBucket: 'cube-broker.firebasestorage.app',
        messagingSenderId: '320940357547',
        appId: '<CUBE_BROKER_WEB_APP_ID>'
    },
};
